/**
 * Minimal auth helpers for the admin dashboard.
 * Token stored in localStorage; all admin API calls go through authFetch.
 */
const TOKEN_KEY = 'twra_admin_token';
const EMAIL_KEY = 'twra_admin_email';
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getAdminEmail = () => localStorage.getItem(EMAIL_KEY);

export const setAuth = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (email) localStorage.setItem(EMAIL_KEY, email);
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};

/**
 * fetch wrapper that automatically attaches Bearer token.
 * Returns Response (caller handles .ok / .json).
 * On 401, clears local auth so the UI can redirect to login.
 */
export const authFetch = async (path, options = {}) => {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (res.status === 401) {
    clearAuth();
  }
  return res;
};

export const login = async (email, password) => {
  const res = await fetch(`${API_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    let msg = 'Login failed';
    if (typeof detail === 'string') msg = detail;
    else if (Array.isArray(detail)) msg = detail.map((e) => e?.msg || '').filter(Boolean).join(' ');
    throw new Error(msg);
  }
  setAuth(data.access_token, data.email);
  return data;
};

export const verifyToken = async () => {
  const token = getToken();
  if (!token) return false;
  const res = await authFetch('/api/auth/me');
  return res.ok;
};
